import { c as _c } from "react/compiler-runtime";
/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
Command: npx gltfjsx@6.2.16 blender/python/python.glb -o src/3d-models/PythonLogoModel.tsx -TtD 
Files: blender/python/python.glb [308.46KB] > C:\Users\Max\projects\leetpal\src\3d-models\python-transformed.glb [65.8KB] (79%)
*/
import { useGLTF } from "@react-three/drei";
import React from "react";
import type * as THREE from "three";
import type { GLTF } from "three-stdlib";
import { assertGltfNodes } from "#/shared/lib/gltfTypeGuard";
type GLTFResult = GLTF & {
  nodes: {
    Main_LP: THREE.Mesh;
    path1950007: THREE.Mesh;
    path1950007_1: THREE.Mesh;
  };
  materials: {
    Main: THREE.MeshStandardMaterial;
    ["Emit Blue LP"]: THREE.MeshStandardMaterial;
    ["Emit Gold LP"]: THREE.MeshStandardMaterial;
  };
};
const assetPath = "/assets/python-transformed.glb";
const REQUIRED_NODES = ["Main_LP", "path1950007", "path1950007_1"] as const;
export function PythonLogoModel(props) {
  const $ = _c(18);
  const gltf = useGLTF(assetPath);
  assertGltfNodes(gltf, REQUIRED_NODES);
  const {
    nodes,
    materials
  } = gltf;
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [Math.PI / 2, 0, 0];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== materials.Main || $[2] !== nodes.Main_LP.geometry) {
    t1 = <mesh geometry={nodes.Main_LP.geometry} material={materials.Main} rotation={t0} scale={200} />;
    $[1] = materials.Main;
    $[2] = nodes.Main_LP.geometry;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = [Math.PI / 2, 0, 0];
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const t3 = materials["Emit Blue LP"];
  let t4;
  if ($[5] !== nodes.path1950007.geometry || $[6] !== t3) {
    t4 = <mesh geometry={nodes.path1950007.geometry} material={t3} />;
    $[5] = nodes.path1950007.geometry;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const t5 = materials["Emit Gold LP"];
  let t6;
  if ($[8] !== nodes.path1950007_1.geometry || $[9] !== t5) {
    t6 = <mesh geometry={nodes.path1950007_1.geometry} material={t5} />;
    $[8] = nodes.path1950007_1.geometry;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t4 || $[12] !== t6) {
    t7 = <group rotation={t2} scale={200}>{t4}{t6}</group>;
    $[11] = t4;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== props || $[15] !== t1 || $[16] !== t7) {
    t8 = <group {...props} dispose={null}>{t1}{t7}</group>;
    $[14] = props;
    $[15] = t1;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  return t8;
}
useGLTF.preload(assetPath);